import {
  CaracteristicasState,
  MetadataState,
  caracteristicasInitialState,
  metadataInitialState,
  CaracteristicasAction,
} from 'store/modules/certificadoRecebiveis/caracteristicas';
import {
  CriteriosRemuneracaoAction,
  criteriosRemuneracaoInitialState,
} from 'store/modules/certificadoRecebiveis/criteriosRemuneracao';
import {
  EventosAction,
  eventosInitialState,
} from 'store/modules/certificadoRecebiveis/eventos';
import {
  UploadDocumentosAction,
  uploadDocumentosInitialState,
} from 'store/modules/certificadoRecebiveis/uploadDocumentos';
import {
  EmissorAction,
  State as EmissorState,
  initialState as emissorInitialState,
} from 'store/modules/certificadoRecebiveis/emissor';
import {
  CriteriosRemuneracao,
  Amortizacao,
  UploadDocumentos,
  TipoRegistroInstrumentoFinanceiro,
  EventosFinanceiros as EventosState
} from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { Attachment } from 'components/uploadDocs';
import { AditamentoAction } from './aditamento';

interface State {
  caracteristicas: CaracteristicasState;
  metadata: MetadataState;
  criteriosRemuneracao: CriteriosRemuneracao;
  emissor: EmissorState;
  eventos: EventosState;
  uploadDocumentos: UploadDocumentos;
  highlightErrors: boolean;
  typeOfRegister: TipoRegistroInstrumentoFinanceiro;
  uploadDocumentoAditamento: Attachment[];
  dataAditamento: string | undefined;
}

export const typeOfRegister = (payload: TipoRegistroInstrumentoFinanceiro) => {
  return typedAction('certificadoRecebiveis/TYPE_OF_REGISTER', payload);
};

export const highlightErrors = (payload: boolean) => {
  return typedAction('certificadoRecebiveis/HIGHLIGHT_ERRORS', payload);
};

export function certificadoRecebiveisReducer(
  state: State = {
    caracteristicas: caracteristicasInitialState,
    metadata: metadataInitialState,
    criteriosRemuneracao: criteriosRemuneracaoInitialState,
    emissor: emissorInitialState,
    eventos: eventosInitialState,
    uploadDocumentos: uploadDocumentosInitialState,
    highlightErrors: false,
    typeOfRegister: TipoRegistroInstrumentoFinanceiro.Cadastro,
    uploadDocumentoAditamento: [],
    dataAditamento: undefined,
  },
  action:
    | CaracteristicasAction
    | CriteriosRemuneracaoAction
    | EmissorAction
    | EventosAction
    | UploadDocumentosAction
    | ReturnType<typeof highlightErrors>
    | ReturnType<typeof typeOfRegister>
    | AditamentoAction
): State {
  switch (action.type) {
    //Características
    case 'certificadoRecebiveis/metadata/UPDATEFIELD':
      return { ...state, metadata: { ...state.metadata, [action.payload.name]: action.payload.value } };
    case 'certificadoRecebiveis/caracteristicas/UPDATEFIELD':
      return { ...state, caracteristicas: { ...state.caracteristicas, [action.payload.name]: action.payload.value } };
    case 'certificadoRecebiveis/caracteristicas/RESET':
      return { ...state, caracteristicas: { ...caracteristicasInitialState } };
    case 'certificadoRecebiveis/caracteristicas/UPDATE':
      return { ...state, caracteristicas: action.payload };
    //Critério de Remuneração
    case 'certificadoRecebiveis/criteriosRemuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: { ...state.criteriosRemuneracao, [action.payload.name]: action.payload.value },
      };
    case 'certificadoRecebiveis/criteriosRemuneracao/remuneracao/UPDATE':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: action.payload,
        },
      };
    case 'certificadoRecebiveis/criteriosRemuneracao/remuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: { ...state.criteriosRemuneracao.remuneracao, [action.payload.name]: action.payload.value },
        },
      };
    case 'certificadoRecebiveis/criteriosRemuneracao/RESET':
      return { ...state, criteriosRemuneracao: criteriosRemuneracaoInitialState };
    case 'certificadoRecebiveis/criteriosRemuneracao/UPDATE':
      return { ...state, criteriosRemuneracao: action.payload };
    //Custo de Emissão
    case 'certificadoRecebiveis/criteriosRemuneracao/custoEmissao/UPDATEFIELD':
      return { 
        ...state, 
        criteriosRemuneracao: { 
          ...state.criteriosRemuneracao, 
          custoEmissao: {
            ...state.criteriosRemuneracao.custoEmissao, [action.payload.name]: action.payload.value },
        }
      };
    //Emissor
    case 'certificadoRecebiveis/emissor/UPDATE_ID':
      return { ...state, emissor: { ...state.emissor, id: action.payload } };
    case 'certificadoRecebiveis/emissor/UPDATE_CODIGO':
      return { ...state, emissor: { ...state.emissor, codigoExterno: action.payload } };
    case 'certificadoRecebiveis/emissor/RESET':
      return { ...state, emissor: { ...emissorInitialState } };
    //Eventos Financeiros
    case 'certificadoRecebiveis/eventos/UPDATE':
      return { ...state, eventos: action.payload };
    case 'certificadoRecebiveis/eventos/UPDATEFIELD':
      return { ...state, eventos: { ...state.eventos, [action.payload.name]: action.payload.value } };
    case 'certificadoRecebiveis/eventos/RESET':
      return { ...state, eventos: eventosInitialState };
    case 'certificadoRecebiveis/eventos/datasPagamentoJuros/UPDATE':
      return {
        ...state,
        eventos: { ...state.eventos, datasPagamentoJuros: action.payload.map((dateViewModel) => dateViewModel.date) },
      };
    case 'certificadoRecebiveis/eventos/datasIncorporacaoJuros/UPDATE':
      return {
        ...state,
        eventos: {
          ...state.eventos,
          datasIncorporacaoJuros: action.payload.map((dateViewModel) => dateViewModel.date),
        },
      };
    case 'certificadoRecebiveis/eventos/amortizacoes/UPDATE':
      const amortizacoes: Amortizacao[] = action.payload.map((amortizacao) => ({
        percentualAmortizacao: amortizacao.percentualAmortizacao,
        dataAmortizacao: amortizacao.dataAmortizacao,
      }));
      return {
        ...state,
        eventos: { ...state.eventos, amortizacoes },
      };
    //Documentos
    case 'certificadoRecebiveis/uploadDocumentos/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documents: action.payload },
      };
    case 'certificadoRecebiveis/uploadDocumentos/documentsToDelete/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documentsToDelete: action.payload },
      };
    case 'certificadoRecebiveis/uploadDocumentos/RESET':
      return { ...state, uploadDocumentos: uploadDocumentosInitialState };
    //Erros
    case 'certificadoRecebiveis/HIGHLIGHT_ERRORS':
      return { ...state, highlightErrors: action.payload };
    //Type of Register
    case 'certificadoRecebiveis/TYPE_OF_REGISTER':
      return { ...state, typeOfRegister: action.payload };
    //Aditamento
    case 'certificadoRecebiveis/UPLOAD_DOCUMENTO_ADITAMENTO':
      return { ...state, uploadDocumentoAditamento: action.payload };
    case 'certificadoRecebiveis/UPLOAD_DOCUMENTO_ADITAMENTO/RESET':
      return { ...state, uploadDocumentoAditamento: [] };
    case 'certificadoRecebiveis/DATA_ADITAMENTO':
      return { ...state, dataAditamento: action.payload };
    case 'certificadoRecebiveis/DATA_ADITAMENTO/RESET':
      return { ...state, dataAditamento: undefined };
    default:
      return state;
  }
}

export default certificadoRecebiveisReducer;
